export default {
    "heatmap": {
        "name": "Heatmap-Diagramm",
        "nodata": "Keine Daten zum Anzeigen",
        "loading": "Laden",
        "maxX": "Maximale Anzahl von Elementen auf der X-Achse",
        "maxY": "Maximale Anzahl von Elementen auf der Y-Achse",
        "rescale": "Achsen neu skalieren",
        "colors": "Farbschema",
        "blue": "Blau",
        "red": "Rot",
        "green": "Grün",
        "diverging": "Abweichend",
        "spectral": "Spektral",
        "cool": "Kalt",
        "defaults": "Standard",
        "showing": "Zeige {shown, number} von {total, number} Elementen",
        "tooltip": "{count, plural, one {# Element} other {# Elemente}}"
    }
};
